export const unselectEl = (self, el) => {
  self._checkNoProcessingTask();
  const selection = self._getSelectionThrowable();
  selection.unselectEl(el);
};
